/**
 * Operations Page — Executions & Audit Trail, Live Activity Monitor, PII Proxy.
 */
import React, { Suspense, useState } from 'react'
import { observer } from 'mobx-react-lite'

const AuditsPage = React.lazy(() => import('./AuditsPage'))
const LiveActivityPage = React.lazy(() => import('./LiveActivityPage'))
const PIIProxyPage = React.lazy(() => import('./PIIProxyPage'))

type Tab = 'executions' | 'live' | 'pii'

const OperationsPage = observer(() => {
  const [activeTab, setActiveTab] = useState<Tab>('executions')

  const tabs: { key: Tab; label: string }[] = [
    { key: 'executions', label: 'Executions & Audit Trail' },
    { key: 'live', label: 'Live Activity' },
    { key: 'pii', label: 'PII Proxy' },
  ]

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl sm:text-2xl font-bold text-foreground">Operations</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Execution history, live monitoring, audit trails, and PII handling
        </p>
      </div>

      <div className="flex gap-1 border-b border-border">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
              activeTab === tab.key
                ? 'border-primary text-primary'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <Suspense fallback={<div className="text-center py-8 text-muted-foreground">Loading...</div>}>
        {activeTab === 'executions' && <AuditsPage />}
        {activeTab === 'live' && <LiveActivityPage />}
        {activeTab === 'pii' && <PIIProxyPage />}
      </Suspense>
    </div>
  )
})

export default OperationsPage
